'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contactItem = require('./contactItem.html');

var _contactItem2 = _interopRequireDefault(_contactItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contactItem = {
    bindings: {
        contact: '=',
        deleteItem: '&',
        advindaContactsCount: '@?',
        customContactsCount: '@?',
        assignedContacts: '=',
        assignedCustomContacts: '='
    },
    template: _contactItem2.default,
    controller: function controller($state) {
        var _this = this;

        this.$onInit = function () {
            _this.isCustomerContact = !!_this.contact.contactInfo.contact.customer;
        };

        this.deleteContact = function () {
            _this.deleteItem(_this.contact);
        };

        this.addToAssignList = function () {
            if (_this.contact.checked) {
                _this.isCustomerContact ? _this.assignedCustomContacts.add(_this.contact.contactInfo.contact.id) : _this.assignedContacts.add(_this.contact.contactInfo.contact.id);
            } else {
                _this.isCustomerContact ? _this.assignedCustomContacts.delete(_this.contact.contactInfo.contact.id) : _this.assignedContacts.delete(_this.contact.contactInfo.contact.id);
            }
        };

        this.getContactUrl = function (contId) {
            if (_this.isCustomerContact) {
                return $state.href('customerContactsDetail', {
                    contactId: contId,
                    isCustomerContact: true,
                    advindaCount: _this.advindaContactsCount,
                    customCount: _this.customContactsCount
                }, { reload: true });
            } else {
                return $state.href('contactsDetail', {
                    contactId: contId,
                    isCustomerContact: false,
                    advindaCount: _this.advindaContactsCount,
                    customCount: _this.customContactsCount
                }, { reload: true });
            }
        };
    }
};

exports.default = contactItem;


/** WEBPACK FOOTER **
 ** ./src/app/directives/contactList/contactItem.js
 **/